<header class="section-header">
  <div class="padding-global">
    <div class="container-small">
      <div class="padding-section-large">
        <div class="cta-content slide-in-0-6s">
          <div class="text-align-center">
            <div class="max-width-xlarge align-center">
              <div class="margin-bottom margin-small">
                <h1 class="text-color-gradient" i18n="@@wf.cta.title">Stop managing Flows. Start Orchestrating Growth</h1>
              </div>
              <p class="text-size-medium" i18n="@@wf.cta.body">Join the next generation of e-commerce brands using predictive intelligence to automate the entire customer lifecycle. From hyper-realistic asset generation to autonomous channel selection, iCortex does the heavy lifting so you can focus on your vision.</p>
              <div class="margin-top margin-medium">
                <div class="button-group is-center">
                  <a [href]="signupHref" class="button is-secondary w-button" i18n="@@wf.cta.primary" (click)="sendGAEvent('Conversion', 'Click', 'Footer CTA signup')">Request Evaluation Access</a>
                  <a [href]="secondaryCtaHref" target="_blank" rel="noopener noreferrer" class="button buttonhero w-button" i18n="@@wf.cta.secondary" (click)="sendGAEvent('Conversion', 'Click', 'Footer CTA demo')">Talk to an Expert</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ellipse"></div>
</header>
